"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IERC165__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var IERC165__factory_1 = require("./IERC165__factory");
Object.defineProperty(exports, "IERC165__factory", { enumerable: true, get: function () { return IERC165__factory_1.IERC165__factory; } });
